class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);

      //NR custom code
      setTimeout(function() {
        cart_page_shipping();
      }, 1200);
      //End NR custom code
    });

    
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    //NR custom code
    update_shipping_related_items();

    if(document.body.classList.contains('cst-cart')){
      cart_page_shipping();
    }
    //End NR custom code

  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        console.log('hhh updated')

        //NR Custom code
         cart_page_shipping();
        //End NR Custom Code
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}




//NR custom code
function update_shipping_related_items(){
  // console.log('hihih')

  //fetch cart
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    // Do something with the cart object
    console.log(cart);

    //related products code
    var items = cart.items;
    var item_length = '';
    for(var i=0; i < items.length; i++){
      if(items.length){
        var item_length = items.length - 1;
      }
    }
    console.log(item_length);
    if (cart.item_count > 0) {
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + items[item_length].product_id + "&limit=8")
        .then(response => response.json())
        .then(({ products }) => {
          if (products.length > 0) {
            const firstRecommendedProduct = products[0];
            console.log('products.length',products.length);
            let htmlthis = '';
    
            for (let i = 0; i < products.length; i++) {
                console.log(products[i].title);
                console.log(products[i].variants.length);
    
                htmlthis += `<div class="ajaxcart__product upcell-product swiper-slide" data-upcell-product="${products[i].variants[0].id}" data-pro-id="${products[i].id}">`;
                htmlthis += `<div class="ajaxcart">`;
                htmlthis += `<div class="upcell-product-img">`;
                htmlthis += `<a href="${products[i].url}" class="ajaxcart__product-image"><img src="${products[i].featured_image}" alt="${products[i].title}"></a>`;
                htmlthis += `</div>`;
    
                htmlthis += `<div class="upcell-product-content">`;
                htmlthis += `<p class="ajax-rtinnerleft">`;
                htmlthis += `<a href="${products[i].url}" class="ajaxcart__product-name">${products[i].title}</a>`;
                htmlthis += `</p>`;
    
                htmlthis += `<div class="add-to-cart-overlay">`;
    
                // if (products[i].variants.length > 1) {
                //   htmlthis += `<button class="cart-btn add-to-cart-image-modal" data-id="${products[i].variants[0].id}">`;
                //   htmlthis += `<font class="small--hide">Add</font>`;
                //   htmlthis += `<font class="medium-up--hide">Add</font> <span class="down_arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>`;
                //   htmlthis += `</button>`;
                // } else {
                //   htmlthis += `<button class="cart-btn add-to-cart-btn" id="AddToCart" data-id="${products[i].variants[0].id}">`;
                //   htmlthis += `<font class="small--hide">Add</font>`;
                //   htmlthis += `<font class="medium-up--hide">Add</font>`;
                //   htmlthis += `</button>`;
                // }

                const isOutOfStock = products[i].variants[0].available;
              
                htmlthis += `<product-form data-section-id="cart-drawer-related">`;
                htmlthis += `<form method="post" action="/cart/add" id="quick-add-cart-drawer-related-${products[i].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">`;
                if(products[i].variants[0].available){
                  htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id">`;
                }else{
                  htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id" disabled>`;
                }
                // htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id" ${isOutOfStock ? ' disabled' : ''}>`;
                htmlthis += `<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="product-id" value="${products[i].id}"><input type="hidden" name="section-id" value="cart-drawer-related">`;
              
                if(products[i].variants[0].available){
                    htmlthis += `<button id="quick-add-cart-drawer-related-${products[i].id}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">`;
                    if(products[i].variants[0].available){
                      htmlthis += `<span>Add - <span class="btnpricee"> ${ Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</span></span>`;
                    }else{
                      htmlthis += `<span>Sold Out</span>`;
                    }
                    htmlthis += `<div class="loading__spinner hidden">`;
                    htmlthis += `<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>`;
                    htmlthis += `</div>`;
                    htmlthis += `</button>`;
                }else{
                    htmlthis += `<button id="quick-add-cart-drawer-related-${products[i].id}-submit" type="submit" name="add" disabled="disabled" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">`;
                    if(products[i].variants[0].available){
                      htmlthis += `<span>Add - ${ Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</span>`;
                    }else{
                      htmlthis += `<span>Sold Out</span>`;
                    }
                    htmlthis += `<div class="loading__spinner hidden">`;
                    htmlthis += `<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>`;
                    htmlthis += `</div>`;
                    htmlthis += `</button>`;
                }
   
                htmlthis += `</form>`;
                htmlthis += `</product-form>`;
    
                // if (products[i].variants.length > 1) {
                //   htmlthis += `<div class="overlay-product-options hidden">`;
                //   htmlthis += `<ul class="product-${products[i].id}">`;
    
                //   for (let j = 0; j < products[i].variants.length; j++) {
                //     const variant = products[i].variants[j];
                //     const price = Shopify.formatMoney(variant.price, 'RM{{amount}}');
                //     const compare = Shopify.formatMoney(variant.compare_at_price, 'RM{{amount}}');
                //     if (variant.available) {
                //       htmlthis += `<li value="${variant.id}">${price}<span class="compare-wrap">${compare}</span> -${variant.title}</li>`;
                //     } else {
                //       htmlthis += `<li value="${variant.id}" class="trigger_bis" data-p-handle="${products[i].handle}">${price}<span class="compare-wrap">${compare}</span> (SOLD OUT) -${variant.title}</li>`;
                //     }
                //   }
    
                //   htmlthis += `</ul>`;
                //   htmlthis += `</div>`;
                // }
    
                htmlthis += `</div>`;
                // htmlthis += `<div class="product-price-div">${Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</div>`;
                htmlthis += `</div></div></div>`;
              
            }
    
            // Set HTML content (vanilla JS)
            const upsellContainer = document.querySelector('cart-drawer .cart_related_products_main');
            if (upsellContainer) {
              upsellContainer.style.display = 'block';
              const related_products = upsellContainer.querySelector('.cart_related_products');
              if(related_products){
                related_products.innerHTML = htmlthis;
              }
            }
    
            const swiperCartdrawer = new Swiper('cart-drawer .swiper-cart-related', {
              loop: false,
              slidesPerView: 2,
              spaceBetween: 10,
              pagination: {
                el: 'cart-drawer .swiper-cart-related .swiper-pagination',
                clickable: true,
              },
              breakpoints: {
                750: {
                  spaceBetween: 15,
                },
              },
            });

            
          }
        })
        .catch(error => {
          console.error('Error fetching recommendations:', error);
        });
    }

    //End related products code

    //add shipping product
      document.getElementById('free_ship_product')?.addEventListener('change', function () {
        const variantId = this.value;
        const isChecked = this.checked;
      
        const endpoint = isChecked ? routes.cart_add_url : routes.cart_change_url;
        const body = isChecked
          ? JSON.stringify({ id: variantId, quantity: 1 })
          : JSON.stringify({ id: variantId, quantity: 0 });
      
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
          body,
        })
          .then((res) => res.json())
          .then(() => {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external' });
          });
      });
    //End Add shipping product
    
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
  });

   
}


//cart page
function cart_page_shipping(){
console.log('hihi')
   //fetch cart
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    // Do something with the cart object
    console.log(cart);

      //shipping bar code
      if (cart.item_count > 0) {
      const shipping_bar_main = document.querySelector('cart-items .free-shipping-progress');
      shipping_bar_main.classList.remove('hidden');
      if(shipping_bar_main){
        const free_shipping_price = shipping_bar_main.querySelector('.free-shipping-progress__text').getAttribute('data-free-shipping-amount');
        if(!free_shipping_price){
          shipping_bar_main.querySelector('.free-shipping-progress__text').style.display = 'none';
          return;
        }

        shipping_bar_main.querySelector('.free-shipping-progress__text').style.display = 'block';
        
        const cartTotal = cart.total_price;
        const freeShippingAmount = free_shipping_price;
        const percentamount = freeShippingAmount/100;
        let progressWithoutPercentage = 0;

        console.log(cartTotal);
        console.log(freeShippingAmount);
        if(cartTotal >= freeShippingAmount){
           progressWithoutPercentage = 100;
          const shippingHTML = "Woohoo!You've got Free Shipping!";
          document.querySelector('cart-items .free-shipping-progress .free-shipping-progress__text .free-shipping-progress__message').innerHTML = shippingHTML;
        }else{
          const remainPercentage = cartTotal/freeShippingAmount*100;
          progressWithoutPercentage = remainPercentage;
          const remainingAmount = freeShippingAmount - cartTotal;
          var shippingHTML = "You're <strong>" + Shopify.formatMoney(remainingAmount, 'RM{{amount}}') + "</strong> away from Free Shipping!";
          document.querySelector('cart-items .free-shipping-progress .free-shipping-progress__text .free-shipping-progress__message').innerHTML = shippingHTML;
        }

        if($('.free-shipping-progress__text').length){
          var i = 0;
          function move(progressWithoutPercentage) {
            var progressWithoutPercentage = parseInt(progressWithoutPercentage);
            if (i == 0) {
              i = 1;
              var elem = document.querySelector("cart-items .free-shipping-progress .free-shipping-progress__bar .free-shipping-progress__bar-fill");
              var width = 1;
              function frame() {
                if (width  >= progressWithoutPercentage) {
                  clearInterval(id);
                  i = 0;
                } else {
                  width++;
                  elem.style.width = width + "%";
                }
              }
              var id = setInterval(frame, 10);
            }
          }
          move(progressWithoutPercentage);
        } 
      }
      }else{
        const shipping_bar_main = document.querySelector('cart-items .free-shipping-progress');
        shipping_bar_main.classList.add('hidden');
      }
    //End shipping bar code


    //related products code
    var items = cart.items;
    var item_length = '';
    for(var i=0; i < items.length; i++){
      if(items.length){
        var item_length = items.length - 1;
      }
    }
    console.log(item_length);
    if (cart.item_count > 0) {
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + items[item_length].product_id + "&limit=8")
        .then(response => response.json())
        .then(({ products }) => {
          if (products.length > 0) {
            const firstRecommendedProduct = products[0];
            console.log('products.length',products.length);
            let htmlthis = '';
    
            for (let i = 0; i < products.length; i++) {
                console.log(products[i].title);
                console.log(products[i].variants.length);
    
                htmlthis += `<div class="ajaxcart__product upcell-product swiper-slide" data-upcell-product="${products[i].variants[0].id}" data-pro-id="${products[i].id}">`;
                htmlthis += `<div class="ajaxcart">`;
                htmlthis += `<div class="upcell-product-img">`;
                htmlthis += `<a href="${products[i].url}" class="ajaxcart__product-image"><img src="${products[i].featured_image}" alt="${products[i].title}"></a>`;
                htmlthis += `</div>`;
    
                htmlthis += `<div class="upcell-product-content">`;
                htmlthis += `<p class="ajax-rtinnerleft">`;
                htmlthis += `<a href="${products[i].url}" class="ajaxcart__product-name">${products[i].title}</a>`;
                htmlthis += `</p>`;
    
                htmlthis += `<div class="add-to-cart-overlay">`;
    
                // if (products[i].variants.length > 1) {
                //   htmlthis += `<button class="cart-btn add-to-cart-image-modal" data-id="${products[i].variants[0].id}">`;
                //   htmlthis += `<font class="small--hide">Add</font>`;
                //   htmlthis += `<font class="medium-up--hide">Add</font> <span class="down_arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>`;
                //   htmlthis += `</button>`;
                // } else {
                //   htmlthis += `<button class="cart-btn add-to-cart-btn" id="AddToCart" data-id="${products[i].variants[0].id}">`;
                //   htmlthis += `<font class="small--hide">Add</font>`;
                //   htmlthis += `<font class="medium-up--hide">Add</font>`;
                //   htmlthis += `</button>`;
                // }

                const isOutOfStock = products[i].variants[0].available;
              
                htmlthis += `<product-form data-section-id="cart-drawer-related">`;
                htmlthis += `<form method="post" action="/cart/add" id="quick-add-cart-drawer-related-${products[i].id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">`;
                if(products[i].variants[0].available){
                  htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id">`;
                }else{
                  htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id" disabled>`;
                }
                // htmlthis += `<input type="hidden" name="id" value="${products[i].variants[0].id}" class="product-variant-id" ${isOutOfStock ? ' disabled' : ''}>`;
                htmlthis += `<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="product-id" value="${products[i].id}"><input type="hidden" name="section-id" value="cart-drawer-related">`;
              
                if(products[i].variants[0].available){
                    htmlthis += `<button id="quick-add-cart-drawer-related-${products[i].id}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">`;
                    if(products[i].variants[0].available){
                      htmlthis += `<span>Add - <span class="btnpricee"> ${ Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</span></span>`;
                    }else{
                      htmlthis += `<span>Sold Out</span>`;
                    }
                    htmlthis += `<div class="loading__spinner hidden">`;
                    htmlthis += `<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>`;
                    htmlthis += `</div>`;
                    htmlthis += `</button>`;
                }else{
                    htmlthis += `<button id="quick-add-cart-drawer-related-${products[i].id}-submit" type="submit" name="add" disabled="disabled" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">`;
                    if(products[i].variants[0].available){
                      htmlthis += `<span>Add - ${ Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</span>`;
                    }else{
                      htmlthis += `<span>Sold Out</span>`;
                    }
                    htmlthis += `<div class="loading__spinner hidden">`;
                    htmlthis += `<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>`;
                    htmlthis += `</div>`;
                    htmlthis += `</button>`;
                }
   
                htmlthis += `</form>`;
                htmlthis += `</product-form>`;
    
                // if (products[i].variants.length > 1) {
                //   htmlthis += `<div class="overlay-product-options hidden">`;
                //   htmlthis += `<ul class="product-${products[i].id}">`;
    
                //   for (let j = 0; j < products[i].variants.length; j++) {
                //     const variant = products[i].variants[j];
                //     const price = Shopify.formatMoney(variant.price, 'RM{{amount}}');
                //     const compare = Shopify.formatMoney(variant.compare_at_price, 'RM{{amount}}');
                //     if (variant.available) {
                //       htmlthis += `<li value="${variant.id}">${price}<span class="compare-wrap">${compare}</span> -${variant.title}</li>`;
                //     } else {
                //       htmlthis += `<li value="${variant.id}" class="trigger_bis" data-p-handle="${products[i].handle}">${price}<span class="compare-wrap">${compare}</span> (SOLD OUT) -${variant.title}</li>`;
                //     }
                //   }
    
                //   htmlthis += `</ul>`;
                //   htmlthis += `</div>`;
                // }
    
                htmlthis += `</div>`;
                // htmlthis += `<div class="product-price-div">${Shopify.formatMoney(products[i].variants[0].price, 'RM{{amount}}')}</div>`;
                htmlthis += `</div></div></div>`;
              
            }
    
            // Set HTML content (vanilla JS)
            const cartupsellContainer = document.querySelector('.cst-cart .cart__footer-wrapper .cart_related_products_main');
            if (cartupsellContainer) {
              cartupsellContainer.style.display = 'block';
              const cartrelated_products = cartupsellContainer.querySelector('.cart_related_products');
              if(cartrelated_products){
                cartrelated_products.innerHTML = htmlthis;
              }
            }
    
            const swiperCart = new Swiper('.cart__footer-wrapper .swiper-cart-related', {
              loop: false,
              slidesPerView: 2,
              spaceBetween: 10,
              pagination: {
                el: '.cart__footer-wrapper .swiper-cart-related .swiper-pagination',
                clickable: true,
              },
              breakpoints: {
                750: {
                  spaceBetween: 15,
                  slidesPerView: 4,
                },
              },
            });
            
          }
        })
        .catch(error => {
          console.error('Error fetching recommendations:', error);
        });
    }else{
     const cartupsellContainer = document.querySelector('.cst-cart .cart__footer-wrapper .cart_related_products_main');
      if (cartupsellContainer) {
        cartupsellContainer.style.display = 'none';
        const cartrelated_products = cartupsellContainer.querySelector('.cart_related_products');
        if(cartrelated_products){
          cartrelated_products.innerHTML = '';
        }
      }
    }

    //End related products code
    
  });
}
//End NR custom code
